import React, { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { LeaderboardTable } from "@/components/LeaderboardTable";
import { api } from "@/lib/api";

const selectCls = "w-full max-w-xs rounded-xl border border-[#e4d8c4] bg-white px-3 py-2.5 text-sm text-[#00334a]";

export default function LeaderboardTab() {
  const [campaigns, setCampaigns] = useState([]);
  const [campaignId, setCampaignId] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/campaigns").then(({ data }) => setCampaigns(data)); }, []);

  useEffect(() => {
    const q = campaignId ? `?campaign_id=${campaignId}` : "";
    api.get(`/leaderboard${q}`).then(({ data }) => setRows(data)).catch(() => {});
  }, [campaignId]);

  return (
    <div className="space-y-6" data-testid="admin-leaderboard">
      <div>
        <span className="hf-eyebrow">Friendly competition</span>
        <h1 className="mt-1 flex items-center gap-2 font-heading text-3xl font-extrabold text-[#00334a]">
          <Trophy className="h-7 w-7 text-[#c99a4e]" /> Leaderboard
        </h1>
      </div>
      <select value={campaignId} onChange={(e) => setCampaignId(e.target.value)} className={selectCls} data-testid="leaderboard-campaign-select">
        <option value="">All campaigns</option>
        {campaigns.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      <LeaderboardTable rows={rows} />
    </div>
  );
}
